import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "crop-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.75 3.00012C7.75 2.58591 7.41421 2.25012 7 2.25012C6.58579 2.25012 6.25 2.58591 6.25 3.00012V6.25012H3C2.58579 6.25012 2.25 6.58591 2.25 7.00012C2.25 7.41434 2.58579 7.75012 3 7.75012H6.25V15.0001C6.25 16.5193 7.48079 17.7501 9 17.7501H16.25V21.0001C16.25 21.4143 16.5858 21.7501 17 21.7501C17.4142 21.7501 17.75 21.4143 17.75 21.0001V17.7501H21C21.4142 17.7501 21.75 17.4143 21.75 17.0001C21.75 16.5859 21.4142 16.2501 21 16.2501H9C8.30921 16.2501 7.75 15.6909 7.75 15.0001V3.00012Z" }, null, -1),
    _createElementVNode("path", { d: "M10.25 7.00012C10.25 6.58591 10.5858 6.25012 11 6.25012H15C16.5192 6.25012 17.75 7.48091 17.75 9.00012V13.0001C17.75 13.4143 17.4142 13.7501 17 13.7501C16.5858 13.7501 16.25 13.4143 16.25 13.0001V9.00012C16.25 8.30934 15.6908 7.75012 15 7.75012H11C10.5858 7.75012 10.25 7.41434 10.25 7.00012Z" }, null, -1)
  ])))
}
export default { render: render }